export default "/_next/static/images/noitems-eb47570aba6fd38f55ed0dbd472c8a16.png";